module.exports = __webpack_public_path__ + "img/battery_4default.4272883f.png";